class MobileNav {
  constructor() {
    this.nav = document.querySelector("nav.wp-block-navigation");
    this.navOpen = document.querySelector(".nav-open");
    this.navClose = document.querySelector(".nav-close");
    this.body = document.querySelector("body");
    this.events();
  }

  events() {
    this.navOpen.addEventListener("click", this.toggleMobileNav.bind(this));
    this.navClose.addEventListener("click", this.toggleMobileNav.bind(this));
  }

  toggleMobileNav() {
    this.body.classList.toggle("nav-open");

    if (this.nav.classList.contains("slide-in")) {
      this.nav.classList.remove("slide-in");
      setTimeout(() => {
        this.nav.classList.add("hidden");
        this.nav.classList.add("open");
      }, 0);
      this.navOpen.setAttribute("aria-expanded", "false");
    } else {
      this.nav.classList.remove("hidden");
      void this.nav.offsetWidth;
      this.nav.classList.add("slide-in");
      this.nav.classList.add("open");
      this.navOpen.setAttribute("aria-expanded", "true");
    }
  }
}

export default MobileNav;
